(function () {
  'use strict';

  // Dealer finder: filter by town or name, or sort by distance from a UK postcode.
  var root = document.querySelector('[data-ezl-dealers]');
  if (!root) return;
  var input = root.querySelector('[data-ezl-dealers-input]');
  var list = root.querySelector('[data-ezl-dealers-list]');
  var title = root.querySelector('[data-ezl-dealers-title]');
  var message = root.querySelector('[data-ezl-dealers-msg]');
  var empty = root.querySelector('[data-ezl-dealers-empty]');
  var items = Array.prototype.slice.call(list.children);
  var timer = null;
  var token = 0;

  items.forEach(function (item) {
    var link = item.querySelector('[data-ezl-dealer-dir]');
    link.setAttribute('data-default', link.getAttribute('href'));
  });

  function miles(lat1, lng1, lat2, lng2) {
    var rad = Math.PI / 180;
    var dLat = (lat2 - lat1) * rad;
    var dLng = (lng2 - lng1) * rad;
    var a = Math.pow(Math.sin(dLat / 2), 2) + Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.pow(Math.sin(dLng / 2), 2);
    return 2 * 3958.8 * Math.asin(Math.sqrt(a));
  }

  function say(text) {
    message.textContent = text || '';
    message.hidden = !text;
  }

  function reset() {
    items.forEach(function (item) {
      item.hidden = false;
      list.appendChild(item);
      item.querySelector('[data-ezl-dealer-dist]').hidden = true;
      item.querySelector('[data-ezl-dealer-tag]').textContent = 'Authorised Dealer';
      var link = item.querySelector('[data-ezl-dealer-dir]');
      link.setAttribute('href', link.getAttribute('data-default'));
    });
  }

  function filter(query) {
    var count = 0;
    reset();
    items.forEach(function (item) {
      var match = !query || item.getAttribute('data-search').indexOf(query) > -1;
      item.hidden = !match;
      if (match) count += 1;
    });
    title.textContent = count + (count === 1 ? ' dealer' : ' dealers') + ' found';
    empty.hidden = count > 0;
  }

  function nearest(lat, lng, label) {
    reset();
    items.map(function (item) {
      return { item: item, distance: miles(lat, lng, parseFloat(item.getAttribute('data-lat')), parseFloat(item.getAttribute('data-lng'))) };
    }).sort(function (a, b) {
      return a.distance - b.distance;
    }).forEach(function (entry, index) {
      var item = entry.item;
      var badge = item.querySelector('[data-ezl-dealer-dist]');
      list.appendChild(item);
      if (!isNaN(entry.distance)) {
        badge.textContent = '~' + entry.distance.toFixed(1) + ' miles away';
        badge.hidden = false;
      }
      if (index === 0) item.querySelector('[data-ezl-dealer-tag]').textContent = 'Nearest Dealer';
      item.querySelector('[data-ezl-dealer-dir]').setAttribute('href', 'https://www.google.com/maps/dir/?api=1&origin=' + encodeURIComponent(label) + '&destination=' + encodeURIComponent(item.getAttribute('data-name') + ' ' + item.getAttribute('data-address')));
    });
    title.textContent = 'Nearest dealers to ' + label;
    empty.hidden = true;
  }

  function run() {
    var query = input.value.trim();
    var mine = ++token;
    say('');
    if (/^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i.test(query)) {
      say('Looking up your postcode…');
      fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(query.replace(/\s+/g, '')))
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (mine !== token) return;
          if (data && data.status === 200 && data.result) {
            say('');
            nearest(data.result.latitude, data.result.longitude, data.result.postcode);
          } else {
            filter('');
            say("That postcode wasn't recognised. Showing all dealers below.");
          }
        })
        .catch(function () {
          if (mine !== token) return;
          filter('');
          say("We couldn't look up that postcode. Showing all dealers below.");
        });
      return;
    }
    filter(query.toLowerCase());
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(run, 300);
  });
})();
